export default function NextLink({nextPage, ...props}) {

  return (
    <>
      {nextPage && (
        <li>
          <p onClick={() => props.onPaginationClick(nextPage)} className="flex items-center justify-center px-3 h-8 leading-tight text-green-600 hover:underline bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 cursor-pointer rounded-e-lg">
            <span className="sr-only">Next</span>
            <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
            </svg>
          </p>
        </li>
      )}
    </>
  )
}
